<script setup lang="ts">
/**
 * The template's second accordion style: dark hairline cards that fill black
 * when open, with a small lilac chevron that flips.
 *
 * Built on native <details> so it works without JavaScript and every answer is
 * in the server HTML. Passing `name` groups the items so only one stays open,
 * which is what the template's script did.
 */
export interface SofaxAccordionItem {
  id: string
  question: string
  answer: string
}

withDefaults(defineProps<{
  items: SofaxAccordionItem[]
  /** Two columns on large screens, as on the template's FAQ page. */
  columns?: 1 | 2
  /** Index of the item open on load; -1 for none. */
  defaultOpen?: number
  /** Shared <details name> so opening one closes the others. */
  name?: string
}>(), {
  columns: 1,
  defaultOpen: 0,
})
</script>

<template>
  <div class="grid grid-cols-1 gap-6" :class="columns === 2 ? 'lg:grid-cols-2' : ''">
    <details
      v-for="(item, index) in items"
      :key="item.id"
      class="accordion-item-style-2"
      :name="name"
      :open="index === defaultOpen"
    >
      <summary>
        <span class="flex-1 text-left">{{ item.question }}</span>
        <span class="accordion-icon">
          <i class="bi bi-chevron-down text-sm" />
        </span>
      </summary>
      <div class="accordion-body">
        <p>{{ item.answer }}</p>
      </div>
    </details>
  </div>
</template>
